@if (campaignViewFilterForm) {
  <form class="filter-context-wrapper" [formGroup]="campaignViewFilterForm">
    <div class="flex gap-4 items-center">
      @if (filterConfig.isColumnSelectorEnabled) {
        <div class="block">
          <m-tooltip
            position="top"
            content="Show/hide columns"
            [styleClass]="'flex'">
            <span
              #columnSelectorButton
              class="material-symbols-outlined cursor-pointer text-gray-500 icon-regular lh-1"
              (click)="toggleColumnSelector()"
              >view_week</span
            >
          </m-tooltip>
          <p-listbox
            #columnSelector
            class="column-selector-listbox"
            [options]="campaignViewColumns"
            [multiple]="true"
            [checkbox]="true"
            [showToggleAll]="true"
            formControlName="tableColumns"
            optionLabel="header"
            optionValue="field"
            (onChange)="refreshCampaignRecords()">
            <ng-template pTemplate="filter">
              <span class="text-gray-1000 b1">All</span>
            </ng-template>
          </p-listbox>
        </div>
      }
    </div>
    @if (filterConfig.isGroupByEnabled) {
      <div class="flex gap-2 items-center group-by-dropdown">
        <p-inputGroup>
          <p-inputGroupAddon
            styleClass="c2 py-[5px] text-gray-800 border-gray-500 bg-gray-100"
            >Group By</p-inputGroupAddon
          >
          <m-dropdown
            [options]="groupByDimensions"
            optionLabel="label"
            optionValue="value"
            placeholder="Select dimension"
            formControlName="groupByDimension"
            appendTo="body"
            styleClass="text-gray-800 bg-gray-100 border-gray-500 p-none rounded-r rounded-l-none"
            (formControlChange)="
              refreshCampaignRecords($event?.value, 'groupByDimension')
            "></m-dropdown>
        </p-inputGroup>
      </div>
    }
    <div class="h-8">
      <div class="m-divider vertical"></div>
    </div>
    @if (filterConfig.isAiRecommendationsEnabled) {
      <lib-ui-alpha-feature-enabler>
        <ng-container phase="ai">
          <div class="flex gap-2 items-center">
            <div class="flex gap-2 items-center">
              @if (showAiRecommendations && activeTab === "unmapped") {
                <img
                  alt="AI Sparkles"
                  src="assets/images/sparkles.svg"
                  width="16px"
                  height="16px" />
              }
              <span class="b1 text-gray-800">Show AI Recommendations</span>
            </div>
            <m-switch
              class="m-switch-small"
              size="small"
              [isToggle]="false"
              [trueValue]="true"
              [falseValue]="false"
              formControlName="showAiRecommendations"
              (onChange)="onAiRecommendationsToggle($event)">
            </m-switch>
            <div class="h-8">
              <div class="m-divider vertical"></div>
            </div>
          </div>
        </ng-container>
      </lib-ui-alpha-feature-enabler>
    }
    @if (filterConfig.isDimensionSelectorEnabled) {
      <div class="flex gap-2 items-center">
        <span class="text-gray-800 b2">Group by</span>
        <m-dropdown
          [style]="{ width: '10rem' }"
          [options]="groupByDimensions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select dimension"
          formControlName="groupByDimension"
          appendTo="body"
          (formControlChange)="
            refreshCampaignRecords($event?.value, 'groupByDimension')
          "></m-dropdown>
      </div>
    }
    @if (filterConfig.isDateRangeEnabled) {
      <m-dropdown
        [style]="{ width: '12rem' }"
        [options]="dateRangeOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Select date range"
        formControlName="dateRange"
        appendTo="body"
        (formControlChange)="
          refreshCampaignRecords($event?.value, 'dateRange')
        "></m-dropdown>
    }
    @if (filterConfig.isSearchEnabled) {
      <span
        class="saas-input-icon-right saas-ui saas-ui-size-default"
        style="width: 11rem">
        <span
          class="material-symbols-outlined saas-icon text-blue-600 cursor-pointer"
          (click)="refreshCampaignRecords()"
          >search</span
        >
        <input
          id="dimension-search"
          type="text"
          pInputText
          [placeholder]="accordionFilterPlaceholder"
          formControlName="dimensionFilter"
          (keyup)="refreshCampaignRecords()"
          autocomplete="off" />
      </span>
    }

    @if (filterConfig.isApprovalEnabled) {
      <div class="flex gap-2 items-center">
        <m-button
          styleClass="saas-ui saas-ui-size-default px-3 py-[5px]"
          (click)="onApproveAll()">
          Approve All</m-button
        >
      </div>
    }
    @if (filterConfig.isGroupByTextVisible) {
      <div class="flex gap-1 items-center">
        <div>
          <span
            class="material-symbols-outlined cursor-pointer text-gray-600 icon-regular icon-filled h-3">
            filter_alt
          </span>
        </div>
        <div>
          <span class="text-gray-600 b1 fw-400 text-sm"
            >Grouped by data source</span
          >
        </div>
      </div>
    }
  </form>
}
